import { skipToken, useSuspenseQuery } from '@apollo/client'
import { FetchEltModelsDocument, FetchViewsDocument, ViewConfigTypeEnum } from '@salescore/client-api'
import { getOrganizationIdFromPath } from '@salescore/client-common'
import { ModelFormViewForm } from '@salescore/client-feature-setting'
import { createFileRoute } from '@tanstack/react-router'
import { isUndefined } from 'effect/Predicate'
import type { ReactElement } from 'react'

//
// モデルに紐づくフォームUIの設定ページ
//
const Page = (): ReactElement => {
  const { modelName } = Route.useParams()
  const { data } = useSuspenseQuery(FetchEltModelsDocument, {
    variables: { organizationId: getOrganizationIdFromPath() },
  })
  const models = data.eltModels
  const model = models.find((x) => x.name === modelName)
  const { data: query, refetch: invalidate } = useSuspenseQuery(
    FetchViewsDocument,
    isUndefined(model)
      ? skipToken
      : {
          variables: {
            organizationId: getOrganizationIdFromPath(),
            type: ViewConfigTypeEnum.Form,
            modelName: model.name,
          },
        },
  )
  if (isUndefined(model) || isUndefined(query)) {
    return <></>
  }
  const [formView] = query.views // つねに1つ以下しかないはず

  return (
    <div className="p-8">
      <ModelFormViewForm
        key={formView?.id ?? 'new-form'}
        formView={formView}
        model={model}
        onAfterFinish={() => {
          void invalidate()
        }}
      />
    </div>
  )
}

export const Route = createFileRoute('/o/$organizationId/v2/settings/elt_models/$modelName/form')({
  component: Page,
})
